import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-59f0b6fa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "nonbid_ok" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("被保证人")
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_4 = /*#__PURE__*/_createTextVNode("和受益人")
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "model" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "title" }, " 被保证人 "),
  /*#__PURE__*/_createElementVNode("div", { class: "list" }, [
    /*#__PURE__*/_createElementVNode("p", null, "产品种类：履约保函"),
    /*#__PURE__*/_createElementVNode("p", null, "出函机构：深圳中联银融资担保有限公司"),
    /*#__PURE__*/_createElementVNode("p", null, "被保证人名称：深圳蔓延科技有限公司"),
    /*#__PURE__*/_createElementVNode("p", null, "统一信用代码：879789IUEIO896767869"),
    /*#__PURE__*/_createElementVNode("p", null, "企业法人：张三"),
    /*#__PURE__*/_createElementVNode("p", null, "法人电话号码：18612345678"),
    /*#__PURE__*/_createElementVNode("p", null, "联系人：李四"),
    /*#__PURE__*/_createElementVNode("p", null, "联系电话：18658985689")
  ])
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "model" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "title" }, " 受益人 "),
  /*#__PURE__*/_createElementVNode("div", { class: "list" }, [
    /*#__PURE__*/_createElementVNode("p", null, "受益人名称：深圳蔓延科技有限公司"),
    /*#__PURE__*/_createElementVNode("p", null, "统一信用代码：879789IUEIO896767869")
  ])
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "model" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "title" }, " 项目信息 "),
  /*#__PURE__*/_createElementVNode("div", { class: "list" }, [
    /*#__PURE__*/_createElementVNode("p", null, "项目名称：萨达所大所大"),
    /*#__PURE__*/_createElementVNode("p", null, "保函金额：100万元"),
    /*#__PURE__*/_createElementVNode("p", null, "保函金额（大写）：壹佰万元"),
    /*#__PURE__*/_createElementVNode("p", null, "项目负责人：张三"),
    /*#__PURE__*/_createElementVNode("p", null, "负责人手机号码：18612345678"),
    /*#__PURE__*/_createElementVNode("p", null, "担保期限：365天"),
    /*#__PURE__*/_createElementVNode("p", null, [
      /*#__PURE__*/_createTextVNode("保函格式："),
      /*#__PURE__*/_createElementVNode("a", { href: "" }, "独立特殊（见索既付）")
    ])
  ])
], -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "model" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "title" }, " 反担保1 "),
  /*#__PURE__*/_createElementVNode("div", { class: "list" }, [
    /*#__PURE__*/_createElementVNode("p", null, "反担保类型：个人反担保"),
    /*#__PURE__*/_createElementVNode("p", null, "反担保措施：项目负责人"),
    /*#__PURE__*/_createElementVNode("p", null, "反担保人：张三"),
    /*#__PURE__*/_createElementVNode("p", null, "证件号码：12345678912355"),
    /*#__PURE__*/_createElementVNode("p", null, "手机号码：18612345678"),
    /*#__PURE__*/_createElementVNode("p", null, "通讯地址：深圳市福田区振华路14号设计大厦"),
    /*#__PURE__*/_createElementVNode("p", null, "反担保合同签署方式：线下签署"),
    /*#__PURE__*/_createElementVNode("p", null, [
      /*#__PURE__*/_createTextVNode("反担保财产证明材料："),
      /*#__PURE__*/_createElementVNode("a", { href: "" }, "清水苑11栋23室房产购买合同")
    ]),
    /*#__PURE__*/_createElementVNode("p", null, [
      /*#__PURE__*/_createTextVNode("反担保合同模板："),
      /*#__PURE__*/_createElementVNode("a", { href: "" }, "反担保合同-个人")
    ])
  ])
], -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "model" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "title" }, " 反担保2 "),
  /*#__PURE__*/_createElementVNode("div", { class: "list" }, [
    /*#__PURE__*/_createElementVNode("p", null, "反担保类型：个人反担保"),
    /*#__PURE__*/_createElementVNode("p", null, "反担保措施：项目负责人"),
    /*#__PURE__*/_createElementVNode("p", null, "反担保人：张三"),
    /*#__PURE__*/_createElementVNode("p", null, "证件号码：12345678912355"),
    /*#__PURE__*/_createElementVNode("p", null, "手机号码：18612345678"),
    /*#__PURE__*/_createElementVNode("p", null, "通讯地址：深圳市福田区振华路14号设计大厦"),
    /*#__PURE__*/_createElementVNode("p", null, "反担保合同签署方式：线下签署"),
    /*#__PURE__*/_createElementVNode("p", null, [
      /*#__PURE__*/_createTextVNode("反担保财产证明材料："),
      /*#__PURE__*/_createElementVNode("a", { href: "" }, "清水苑11栋23室房产购买合同")
    ]),
    /*#__PURE__*/_createElementVNode("p", null, [
      /*#__PURE__*/_createTextVNode("反担保合同模板："),
      /*#__PURE__*/_createElementVNode("a", { href: "" }, "反担保合同-个人")
    ])
  ])
], -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"padding-top":"54px"} }, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "model" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "title" }, " 收费 "),
  /*#__PURE__*/_createElementVNode("div", { class: "list" }, [
    /*#__PURE__*/_createElementVNode("p", null, "收费模式：先出函后支付"),
    /*#__PURE__*/_createElementVNode("p", null, "保费总金额：10000.00元"),
    /*#__PURE__*/_createElementVNode("p", null, "保费金额（大写）：壹万元"),
    /*#__PURE__*/_createElementVNode("p", null, "应缴保证金金额：4121.55元"),
    /*#__PURE__*/_createElementVNode("p", null, "客户实缴保证金金额：1121.55元"),
    /*#__PURE__*/_createElementVNode("p", null, "机构代垫保证金金额：3000元")
  ])
], -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "model" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "title" }, " 协议 "),
  /*#__PURE__*/_createElementVNode("div", { class: "list" }, [
    /*#__PURE__*/_createElementVNode("p", null, "委托担保协议签署方式：线下签署"),
    /*#__PURE__*/_createElementVNode("p", null, [
      /*#__PURE__*/_createTextVNode("委托担保协议模板："),
      /*#__PURE__*/_createElementVNode("a", { href: "" }, "委托担保协议模板")
    ]),
    /*#__PURE__*/_createElementVNode("p", null, "征信查询函签署方式：线下签署"),
    /*#__PURE__*/_createElementVNode("p", null, [
      /*#__PURE__*/_createTextVNode("征信查询函模板："),
      /*#__PURE__*/_createElementVNode("a", { href: "" }, "征信查询函模板")
    ]),
    /*#__PURE__*/_createElementVNode("p", null, "保函出函方式：线下纸质保函"),
    /*#__PURE__*/_createElementVNode("p", null, [
      /*#__PURE__*/_createTextVNode("保函模板："),
      /*#__PURE__*/_createElementVNode("a", { href: "" }, "独立式保函模板")
    ])
  ])
], -1))
const _hoisted_13 = { class: "btn" }
const _hoisted_14 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_tab = _resolveComponent("van-tab")!
  const _component_van_tabs = _resolveComponent("van-tabs")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_tabs, {
      active: _ctx.active,
      "onUpdate:active": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.active) = $event)),
      ellipsis: false,
      sticky: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_tab, { title: "被保证人和受益人" }, {
          title: _withCtx(() => [
            _hoisted_2,
            _hoisted_3,
            _hoisted_4
          ]),
          default: _withCtx(() => [
            _hoisted_5,
            _hoisted_6
          ]),
          _: 1
        }),
        _createVNode(_component_van_tab, { title: "项目信息" }, {
          default: _withCtx(() => [
            _hoisted_7
          ]),
          _: 1
        }),
        _createVNode(_component_van_tab, { title: "反担保信息" }, {
          default: _withCtx(() => [
            _hoisted_8,
            _hoisted_9,
            _hoisted_10
          ]),
          _: 1
        }),
        _createVNode(_component_van_tab, { title: "收费和协议" }, {
          default: _withCtx(() => [
            _hoisted_11,
            _hoisted_12
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["active"]),
    _createElementVNode("div", _hoisted_13, [
      (_ctx.active === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_14))
        : (_openBlock(), _createElementBlock("div", {
            key: 1,
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.active--))
          }, "上一项")),
      (_ctx.active < 3)
        ? (_openBlock(), _createElementBlock("div", {
            key: 2,
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.active++))
          }, "下一项"))
        : (_openBlock(), _createElementBlock("div", {
            key: 3,
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$router.push('/order')))
          }, "我已确认并提交"))
    ])
  ]))
}